import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Live-edits one agent's (buyer or seller) persona text. Works while the
 * simulation is running — it takes effect on that agent's very next tick.
 * Response echoes `{ simulationId, agentConversationId, personaPrompt }`.
 */
const updateSimulationAgentPersona = (
  simulationId,
  agentConversationId,
  personaPrompt,
  callback,
  errorCallback,
) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.patch(
            `/ads/admin/simulations/${simulationId}/agents/${agentConversationId}/persona`,
            { personaPrompt },
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to update persona');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to update persona',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to update persona');
    }
  };
};

export default updateSimulationAgentPersona;
